
import { BookOpen, FileText, MessageCircle, Users, Calendar, BookOpen as Book } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const services = [
  {
    icon: <MessageCircle className="h-12 w-12 text-crimson" />,
    title: "Q&A Sessions",
    description: "Get answers to your specific questions about universities, programs, or application processes."
  },
  {
    icon: <FileText className="h-12 w-12 text-crimson" />,
    title: "Resume Review",
    description: "Receive detailed feedback to optimize your resume for university or job applications."
  },
  {
    icon: <BookOpen className="h-12 w-12 text-crimson" />,
    title: "Essay Review",
    description: "Get your essays reviewed by alumni who successfully navigated the admissions process."
  },
  {
    icon: <Users className="h-12 w-12 text-crimson" />,
    title: "Case Preparation",
    description: "Practice case interviews with experienced alumni from consulting or business backgrounds."
  },
  {
    icon: <Book className="h-12 w-12 text-crimson" />,
    title: "Test Preparation",
    description: "Get strategic advice and preparation tips for standardized tests from high-scoring alumni."
  },
  {
    icon: <Calendar className="h-12 w-12 text-crimson" />,
    title: "Admission Consulting",
    description: "Comprehensive guidance throughout your application process to increase acceptance chances."
  }
];

const ServicesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Services We Offer</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our alumni provide a variety of services to help you succeed in your academic and professional journey
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="border-silver/10 hover:border-crimson/30 transition-colors duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6">
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 p-3 bg-crimson/10 rounded-full">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
